import React from 'react';
import { observer } from 'mobx-react-lite';
import { FiltersObject, PaginationDelegate } from 'store/general/paginationDelegate';
import { EmployeeInvitationStatusTypes, SubscribersSortBy, SubscribersSortOrder } from 'types/electionService';
import { FilterDropdown } from 'components/common/general/CollectionManagementPanel/FilterDropdown';

const STATUS_FILTER_TITLES = {
  [EmployeeInvitationStatusTypes.ADD_MAIL]: 'Email Missing',
  [EmployeeInvitationStatusTypes.NOT_YET_INVITED]: 'Not Yet Invited',
  [EmployeeInvitationStatusTypes.INVITED]: 'Invited',
  [EmployeeInvitationStatusTypes.REGISTERED]: 'Registered',
  [EmployeeInvitationStatusTypes.ELECTED]: '',
};

interface InitiateAddEmployeesFilters extends FiltersObject {
  status: EmployeeInvitationStatusTypes | null;
}

interface Props {
  paginationDelegate: PaginationDelegate<SubscribersSortBy, SubscribersSortOrder, InitiateAddEmployeesFilters>;
}

export const EmployeesStatusFilterDropdown: React.FC<Props> = observer(({ paginationDelegate }) => {
  if (!!paginationDelegate.filters.status && !STATUS_FILTER_TITLES[paginationDelegate.filters.status]) {
    throw new Error(`Unsupported filter value assigned! ${paginationDelegate.filters.status}`);
  }
  return (
    <FilterDropdown
      filterName="Status"
      $minWidth="26rem"
      optionsWidth="26rem"
      selectedFilterLabel={
        paginationDelegate.filters.status ? STATUS_FILTER_TITLES[paginationDelegate.filters.status] : 'All'
      }
      filtersList={[
        { value: null, label: 'All' },
        {
          value: EmployeeInvitationStatusTypes.ADD_MAIL,
          label: STATUS_FILTER_TITLES[EmployeeInvitationStatusTypes.ADD_MAIL],
        },
        {
          value: EmployeeInvitationStatusTypes.NOT_YET_INVITED,
          label: STATUS_FILTER_TITLES[EmployeeInvitationStatusTypes.NOT_YET_INVITED],
        },
        {
          value: EmployeeInvitationStatusTypes.INVITED,
          label: STATUS_FILTER_TITLES[EmployeeInvitationStatusTypes.INVITED],
        },
        {
          value: EmployeeInvitationStatusTypes.REGISTERED,
          label: STATUS_FILTER_TITLES[EmployeeInvitationStatusTypes.REGISTERED],
        },
      ]}
      applyFilter={(value: string | null) => {
        paginationDelegate.setFilterValue('status', value as EmployeeInvitationStatusTypes);
      }}
    />
  );
});
